export const FROM_11PM_TO_6AM = 'FROM_11PM_TO_6AM';
export const FROM_6AM_TO_2PM_AND_7PM_TO_11PM = 'FROM_6AM_TO_2PM_AND_7PM_TO_11PM';
export const FROM_2PM_TO_7PM = 'FROM_2PM_TO_7PM';
export const ALL_HOURS = "ALL_HOURS";
